import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/16/solid';
import { ErrorLogSortDirectionType } from 'types/error-log';

type ErrorLogSortHeaderProps = {
  label: string;
  direction: ErrorLogSortDirectionType;
  onToggle: () => void;
};

export default function ErrorLogSortHeader({
  label,
  direction,
  onToggle
}: ErrorLogSortHeaderProps) {
  const SortIcon = direction === 'asc' ? ChevronUpIcon : ChevronDownIcon;

  return (
    <button
      type='button'
      className='inline-flex items-center gap-1 text-sm font-semibold text-gray-900 hover:text-gray-700'
      onClick={onToggle}
    >
      {label}
      <SortIcon className='h-4 w-4 text-gray-500' />
    </button>
  );
}
